import React from "react";
import styled from "styled-components";

import { ArrowLeft, ArrowRight } from "Components/common/kcArrow";

const StyledArrowWrapper = styled.div`
  display: none;
  margin: 0.4rem 0 0.4rem 0.4rem;
  ${(props) => props.theme.responsive.mobile} {
    display: block;
  }
`;

const KCArrowControls = ({
  slideIndex,
  totalSlides,
  handlePrevious,
  handleNext,
}) => {
  return (
    <StyledArrowWrapper>
      <ArrowLeft
        isDisabled={slideIndex === 0}
        onClick={() => handlePrevious()}
      />
      <ArrowRight
        isDisabled={slideIndex > totalSlides}
        onClick={() => handleNext()}
      />
    </StyledArrowWrapper>
  );
};

export default KCArrowControls;
